<template>
  <div v-if="meta_item.sell_info">
    <UiModal :open="status_poppad_open" @close="status_poppad_open = false">

      <!-- step: pad_init -->
      <div v-if="on_step === 'pad_init'" class="p-5">
        <h3 class="tac mb-4">
          {{lg('',{
            en:  'Sell Now',
            zh:  '卖出',
          })}}
        </h3>

        <div class="mb-1">
          {{lg('',{
            en:  'Set Price',
            zh:  '设置价格',
          })}}
        </div>
        <div class="d-flex mb-3">
          <input v-model.number="num_price_sell" type="text" class="form-control">
          <select 
            class="form-control ml-3"
            style="width: 100px;"
            v-model="token_id_sell"
            >
            <option 
              v-for="(item,index) of $store.state.fecfg.cfg_token_type_sell"
              :key="index"
              :value="item.id"
              style="height: 2em;"
              >
              {{item.name}}
            </option>
          </select>
        </div>

        <div class="mb-2">
          <span>
            {{lg('',{
              en:'Service Fee',
              zh:'服务费',
            })}}
          </span>
          <span class="float-right">2.5%</span>
        </div>
        
        <div class="mb-2">
          <span>
            {{lg('',{
              en:'You Will Receive',
              zh:'你将得到',
            })}}
          </span>
          <span class="float-right">
            <b class="c">
              {{num_price_sell * 0.975 | tofixed6}}
              {{lg('',$store.state.web3.account_wallet.find(item => item.id == token_id_sell).names)}}
            </b>
            <span class="t-gray">
              (${{num_price_sell * 0.975 | tokenToUsd(token_id_sell)}} USD)
            </span>

          </span>
        </div>

        <div class="tac mt-4">
          <button 
            :class="['btn btn-primary btn-round',{'op8': !num_price_sell}]"
            style="min-width: 120px;" 
            @click="setStep('pad_approve')"
            >
            {{lg('next')}}
          </button>
        </div>
      </div>

      <!-- step: pad_approve & pad_sell -->
      <div v-if="on_step === 'pad_approve' || on_step === 'pad_sell'" class="p-5">

        <!-- uni top header -->
        <div>
          <h3 class="tac mb-3">
            {{lg('',{
              en:  'Next Step',
              zh:  '下一步',
            })}}
          </h3>
          <div class="mb-3 tac">
            <span :class="['mx-3 b',{'c': on_step === 'pad_approve' || on_step === 'pad_sell'}]">
              <span :class="['ui-step-num',{'on': on_step === 'pad_approve' || on_step === 'pad_sell'}]">
                1
              </span>
              {{lg('',{
                en:  'Confirm',
                zh:  '确认',
              })}}
            </span>
            <span :class="['mx-3 b',{'c': on_step === 'pad_sell'}]">
              <span :class="['ui-step-num',{'on': on_step === 'pad_sell'}]">
                2
              </span>
              {{lg('',{
                en:  'Sign',
                zh:  '签名',
              })}}
            </span>
          </div>
        </div>

        <!-- ui for approve -->
        <div v-if="on_step === 'pad_approve'" class="tac">
          <div 
            class="d-flex justify-content-center align-items-center"
            style="height: 100px;"
            >
            <button 
              class="btn btn-primary btn-round px-4" 
              style="height: 50px;"
              v-if="!status_ajaxing_approve"
              @click="actionApprove()" 
              >
              Approve
            </button>

            <span v-if="status_ajaxing_approve" class="ui-loading-icon"></span>
          </div>
          <div class="mt-4" style="line-height: 1.5em;">
            Confirm transaction with your wallet. Please follow wallet instructions.
          </div>
        </div>

        <!-- ui for sell -->
        <div v-if="on_step === 'pad_sell'" class="tac">
          <div 
            class="d-flex justify-content-center align-items-center"
            style="height: 100px;"
            >
            <button 
              class="btn btn-primary btn-round px-4" 
              style="height: 50px;"
              v-if="!status_sold && !status_ajaxing_sell"
              @click="actionSell()" 
              >
              {{lg('',{
                en: 'Sign Sell Order',
                zh: '签名并卖出',
              })}}
            </button>

            <span v-if="status_ajaxing_sell" class="ui-loading-icon"></span>
            <span v-if="status_sold" class="ui-loading-icon-done"></span>
          </div>
          <div class="mt-4" style="line-height: 1.5em;">
            Sign sell order using your wallet.
          </div>
        </div>
      </div>
      
      <!-- step: done -->
      <div v-if="on_step === 'pad_done'" class="px-5 pt-5">
        <h3 class="tac mb-2">
          {{lg('',{
            en:  'NFT Listed',
            zh:  'NFT 已上架',
          })}}
        </h3>
        <div class="mb-4 tac">
          {{lg('',{
            en:  'Tell your friends about this awesome NFT',
            zh:  '',
          })}}
        </div>

        <div class="pic-holder mb-4">
          <!-- <img :src="item.image" style="height: 200px;"> -->
          <CpNftCoverImg
            style="height: 200px;"
            :src="item.image"
          />
        </div>

        <div v-if="status_poppad_open">
          <BlockShareLinks :share_title="'New NFT listed on JGNNFT!'"/>
        </div>
      </div>
    </UiModal>
  </div>
</template>

<script>
import bus from '@/bus.js'
import {mapActions} from 'vuex'
import BlockShareLinks from './block_share_links.vue'

export default {
  name: 'popSell',
  components: {
    BlockShareLinks,
  },
  props: [
    'item',
    'meta_item',
    'cfg_status_poppad',
    'cfg_price',
  ],
  data() {
    return {
      status_poppad_open: false,

      // 'pad_init', 'pad_approve', 'pad-sign', 'pad-done',
      on_step: 'pad_init',

      // 
      status_approved: false,
      status_ajaxing_approve: false,

      status_sold: false,
      status_ajaxing_sell: false,
      
      // form
      token_id_sell: 'eth', 
      num_price_sell: '',

      // order
      order: null,
    }
  },
  computed: {},
  watch: {
    'cfg_status_poppad'(val){
      if(val){
        this.runPop()
      }
    },
    'status_poppad_open'(val){
      if(!val){
        this.$parent.btnToggleSell(false)
      }
    }
  },
  methods: {
    ...mapActions([
      'sellSignMessage',
      'hasApproveNFT',
      'approveNFT',
    ]),

    getSign(){
      // return new Promise(function(resolve,rejct){
      //   let mark = ''
      //   mark = ('00000'+Math.random()*0x1000000<<0).toString(16).slice(-6) + (new Date()).valueOf()
      //   resolve(mark)
      // })  
      var t = '1234567890'
      var a = t.length
      var n = ''
      for (let index = 0; index < 64; index++) {
        var id = Math.floor(Math.random()*a);
        n += t.charAt(id)
      }
      return n
    },

    async actionSell(){
      let v = this

      let address_my = v.$store.state.web3.account

      console.log('into sell!!!!!!!!!!!')
      let sign = v.getSign()
      console.log(sign)
      //sign = '85519839363420989841396260613813766958312475334488019196817535864339607618641'
      
      let obj = {
        address: address_my,
        address_owner: v.meta_item.owner || v.$route.query.owner,
        sell_price: v.num_price_sell,
        sell_token_id: v.token_id_sell,
        token_address: v.meta_item.nft_address,
        token_id: v.meta_item.nft_id,
        type: v.meta_item.type,
        sign_str: sign,
        callback: function(){
          v.status_ajaxing_sell = false
        },
        callbackOnErr: function(){
          v.status_ajaxing_sell = false
        },
      }

      console.log('action-sell-01: obj',obj)

      v.status_ajaxing_sell = true
      let sig = await v.sellSignMessage(obj)

      console.log('action-sell-01: sig', sig)

      if(!sig){
        return
      }

      let total_value = v.$options.filters['tokenToUsd'](v.num_price_sell * 0.975,v.token_id_sell)

      v.status_ajaxing_sell = true
      v.api('sell',{
        'nft_address': obj.token_address,
        'nft_id': obj.token_id,
        'owner': v.meta_item.owner,
        'amount': 1,
        'salt': obj.sign_str,
        'signature': sig,
        'buyValue':obj.sell_price,
        'currency':obj.sell_token_id,
        'totalValue': total_value,
      }).then(function(res){
        console.log('sell done')
        console.log(res)

        // done
        // v.status_poppad_open = false
        v.on_step = 'pad_done'
        v.status_ajaxing_sell = false
        
        // refresh page
        setTimeout(function(){
          // detail page, or gallery page
          if(v.$parent.run){
            v.$parent.run()
          }
        },2000)
      })
    },
    // 
    async actionApprove(){
      let v = this
      if(v.status_ajaxing_approve){
        return
      }
      let address_my = v.$store.state.web3.account
      let address_nft = v.meta_item.nft_address

      v.status_ajaxing_approve = true
      await v.approveNFT({
        address: address_my,
        NTFS_TOKEN_ADDRESS: address_nft,
        type: v.meta_item.type,
        callback: function(){
          v.status_approved = true
          v.status_ajaxing_approve = false
          v.on_step = 'pad_sell'
        },
        callbackOnErr: function(){
          v.status_ajaxing_approve = false
        },
      })
      
    },

    async checkApprove(){
      let v = this
      let address_my = v.$store.state.web3.account
      let address_nft = v.meta_item.nft_address

      let mark = await v.hasApproveNFT({
        address: address_my,
        NTFS_TOKEN_ADDRESS: address_nft,
        type: v.meta_item.type,
        // todo... contract params...
      })
      v.status_approved = mark
    },

    setStep(str){
      let v = this

      // no price inputed
      if(str === 'pad_approve' && !v.num_price_sell){
        return
      }

      // approved
      if(str === 'pad_approve' && v.status_approved){
        v.on_step = 'pad_sell'
        return
      }
      v.on_step = str
    },

    // run pop
    runPop(){
      let v = this
      let address_my = v.$store.state.web3.account
      if(!address_my){
        // connect wallet
        bus.headervue.modalOpen = true
        this.$parent.btnToggleSell(false)
        return
      }

      // 重置
      v.status_poppad_open = v.cfg_status_poppad
      v.num_price_sell = ''
      v.status_approved = false
      v.status_ajaxing_approve = false
      v.status_sold = false
      v.status_ajaxing_sell = false
      v.on_step = 'pad_init'

      // 配置外部传入的价格
      if(v.cfg_price){
        v.token_id_sell = v.cfg_price.token_id_sell || ''
        v.num_price_sell = v.cfg_price.num_price_sell || ''
      }

      v.checkApprove()
    },
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>